/* eslint-disable react-hooks/rules-of-hooks */
import { useGetGeoNameByGeonameIdAndLangQuery, useGetGeoCityInfoByIdQuery, useGetGeoCountryInfoByIdQuery } from '../features/api/rest/apiGeo';

const useGetGeoNameByGeonameIdAndLang = (geonameId, type) => {
  let nameID;
  if (type === 'city') {
    const { data } = useGetGeoCityInfoByIdQuery(geonameId, { skip: !geonameId });
    nameID = data?.geoname_id;
  } else if (type === 'country') {
    const { data } = useGetGeoCountryInfoByIdQuery(geonameId, { skip: !geonameId });
    nameID = data?.geoname_id;
  }
  const { data } = useGetGeoNameByGeonameIdAndLangQuery({ geonameId: nameID, lang: window.navigator.language.split('-')[0] }, { skip: !nameID });
  return geonameId ? data?.name : '';
};

export default useGetGeoNameByGeonameIdAndLang;
